import * as React from 'react';
import { ArticleHeading2, ArticleParagraph2, ArticleParagraph3 } from '@cian/ui-kit';
import { AgreementField } from '../AgreementField';
import { Button } from '../Button';
import { PhoneField } from '../PhoneField';
import { TimeField } from '../TimeField';
import * as styles from './CallbackForm.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var CallbackForm = function CallbackForm(_ref) {
  var callTime = _ref.callTime,
    errors = _ref.errors,
    isSubmitDisabled = _ref.isSubmitDisabled,
    isSubmitting = _ref.isSubmitting,
    onPhoneChange = _ref.onPhoneChange,
    onSubmit = _ref.onSubmit,
    onTimeChange = _ref.onTimeChange,
    onUserConfirm = _ref.onUserConfirm,
    phoneRef = _ref.phoneRef,
    privacyPolicyUrl = _ref.privacyPolicyUrl,
    values = _ref.values,
    isSMSDisclaimerEnabled = _ref.isSMSDisclaimerEnabled,
    callbackButtonText = _ref.callbackButtonText;
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    "data-testid": "callback-form",
    children: [/*#__PURE__*/_jsx("div", {
      className: styles['title'],
      children: /*#__PURE__*/_jsx(ArticleHeading2, {
        as: "h3",
        children: "\u0417\u0430\u043A\u0430\u0437 \u0437\u0432\u043E\u043D\u043A\u0430 \u043E\u0442 \u0437\u0430\u0441\u0442\u0440\u043E\u0439\u0449\u0438\u043A\u0430"
      })
    }), /*#__PURE__*/_jsxs("form", {
      className: styles['form'],
      onSubmit: onSubmit,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles['form-block'],
        children: /*#__PURE__*/_jsxs("div", {
          className: styles['fields-row'],
          children: [/*#__PURE__*/_jsx("div", {
            className: styles['phone'],
            children: /*#__PURE__*/_jsx(PhoneField, {
              ref: phoneRef,
              label: "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
              error: errors.phone,
              onChange: onPhoneChange,
              value: values.phone,
              disabled: isSubmitting
            })
          }), /*#__PURE__*/_jsx("div", {
            className: styles['time'],
            children: /*#__PURE__*/_jsx(TimeField, {
              label: "\u0412\u0440\u0435\u043C\u044F",
              error: errors.time,
              onChange: onTimeChange,
              value: values.time,
              disabled: isSubmitting
            })
          })]
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles['form-block'],
        children: /*#__PURE__*/_jsx(ArticleParagraph2, {
          color: errors.time ? 'error_100' : 'gray60_100',
          children: callTime
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles['form-block'],
        children: /*#__PURE__*/_jsx(AgreementField, {
          checked: values.isUserConfirmed,
          onChange: onUserConfirm,
          disabled: isSubmitting,
          privacyPolicyUrl: privacyPolicyUrl
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles['button-wrapper'],
        children: /*#__PURE__*/_jsx(Button, {
          loading: isSubmitting,
          disabled: isSubmitDisabled,
          type: "submit",
          children: callbackButtonText
        })
      }), !!isSMSDisclaimerEnabled && /*#__PURE__*/_jsx("div", {
        className: styles['disclaimer'],
        children: /*#__PURE__*/_jsx(ArticleParagraph3, {
          color: "gray60_100",
          children: "\u041D\u0430\u0436\u0438\u043C\u0430\u044F \u043D\u0430 \u201C\u041F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0438\u0442\u044C \u043C\u043D\u0435\u201D \u0432\u044B \u0434\u0430\u0435\u0442\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u043D\u0430 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u043E\u0442 \u0426\u0438\u0430\u043D \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0433\u043E \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0430 \u043E \u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u0437\u0432\u043E\u043D\u043A\u0430 \u0438 \u043D\u043E\u043C\u0435\u0440\u0435 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u0437\u0430\u0441\u0442\u0440\u043E\u0439\u0449\u0438\u043A\u0430"
        })
      })]
    })]
  });
};